var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('TMapMarker',{attrs:{"markers":_vm.markers,"zoom":_vm.zoom}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }